import { ScoreGrid, ScoreGridInput, Country } from '../../../types'
import { client } from '../../../index'
import { SAVE_SCORE_GRID_MUTATION } from '../Mutations'
import { SCORE_GRID_QUERY } from '../Queries'
import { FetchResult } from '@apollo/client'

export const saveScoreGrid = async (meetingId: string, grid: ScoreGridInput | ScoreGrid): Promise<FetchResult> => {
  return client.mutate({
    mutation: SAVE_SCORE_GRID_MUTATION,
    variables: {
      meetingId,
      grid: { id: grid.id, date: grid.date, scoreGoals: grid.scoreGoals },
    },
  })
}

export const saveScoreGridWithRefetch = async (
  meetingId: string,
  grid: ScoreGridInput | ScoreGrid,
  employeeId: string,
  country: Country,
): Promise<FetchResult> => {
  return client.mutate({
    mutation: SAVE_SCORE_GRID_MUTATION,
    variables: {
      meetingId,
      grid: { id: grid.id, date: grid.date, scoreGoals: grid.scoreGoals },
      refetchQueries: [
        {
          query: SCORE_GRID_QUERY,
          variables: {
            meetingId,
            employeeId,
            country,
          },
        },
      ],
    },
  })
}
